import React from "react";
import { motion } from "framer-motion";

const badges = [
  { k: "Biomarkers", l: "extracted from any lab", c: "teal-soft" },
  { k: "Global", l: "lab format compatibility", c: "lav-400" },
  { k: "Research-backed", l: "clinical & behavioral science", c: "teal-soft" },
  { k: "Preventive", l: "AI risk model", c: "coral-400" },
];

export default function Credibility() {
  return (
    <section data-testid="credibility-section" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="rounded-3xl border border-white/[0.08] bg-gradient-to-br from-teal-mid/[0.06] via-ink-800/70 to-lav-500/[0.06] p-8 sm:p-10">
          <div className="text-center">
            <div className="text-[11px] uppercase tracking-[0.22em] text-teal-soft">08 — Built on science</div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl tracking-tighter leading-[1.1] font-medium max-w-3xl mx-auto">
              Serious infrastructure for serious health decisions.
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
            {badges.map((b, i) => (
              <motion.div key={b.l} initial={{ y: 12, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }} transition={{ delay: i * 0.06, duration: 0.5 }}
                data-testid={`credibility-${i}`}
                className="rounded-2xl border border-white/[0.06] bg-ink-900/40 p-5 text-center">
                <div className={`font-heading text-2xl sm:text-3xl tracking-tighter text-${b.c}`}>{b.k}</div>
                <div className="mt-1.5 text-xs text-zinc-400">{b.l}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
